import { render, staticRenderFns } from "./business-information.vue?vue&type=template&id=461b3ec1"
import script from "./business-information.vue?vue&type=script&lang=js"
export * from "./business-information.vue?vue&type=script&lang=js"
import style0 from "./business-information.vue?vue&type=style&index=0&id=461b3ec1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports